<slm-dialog-container
  [title]="data.title ?? 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.TITLE'"
  [buttons]="dialogButtons"
  (fireEvent)="closeDialog($event.event)"
  class="w-max-dialog-wide w-600px block"
>
  <ng-container *ngIf="!data.attachToExists">
    <slm-toggle
      *ngIf="!data.hideAutoOcr"
      label="AUTOMATIC_OCR_ON_UPLOAD"
      class="block mt-2 mb-2"
      [control]="this.fileUploadFormGroup.get('autoOcr')"
      testId="uploadMode"
    ></slm-toggle>
    <slm-message
      message="{{'LBL_ERROR.MAX_FILE_SIZE' | translate : {maxSize: maxFileSizeMB} }}"
      type="info"
    ></slm-message>
    <div class="mt-3 grid-col-2-50 grid-responsive ">
      <ng-container *ngIf="!data.hideUploadOptions">
        <div
          class="mr-1"
        >
          <slm-select-input
            label="UPLOAD_MODE"
            class="flex-grow-auto"
            [options]="fileUploadModeOptions"
            [control]="this.fileUploadFormGroup.get('uploadMode')"
            testId="uploadMode"
          ></slm-select-input>
        </div>
        <div

          *ngIf="useDivisions$ | async"
        >
          <slm-user-division-select
            [control]="this.fileUploadFormGroup.get('userDivisionId')"
            [useDefaultIfMany]="true"
          ></slm-user-division-select>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <slm-document-item
    *ngFor="let document of documentsSignal(); let i = index; trackBy: trackById"
    [file]="document.file"
    [name]="document.name"
    [hideOpen]="document.hideOpen || data.hideAllOpenIcon"
    [hideClose]="document.hideClose"
    [status]="document.status"
    [progress]="document.progress"
    [ocrColumn]="document.ocrIcon"
    [ocrStatus]="document.ocrStatus"
    (fireEvent)="documentEvent(i, $event)"
  ></slm-document-item>
  <slm-drag-and-drop
    [config]="{ width: '100%' }"
    text="LBL_UPLOAD_FILL.UPLOAD_DIALOG.DRAG_DOCUMENT"
    [accept]="data.acceptedFileMimeTypes"
    supportedFiles="images-documents"
    browseButton="LBL_UPLOAD_FILL.UPLOAD_DIALOG.BROWSE"
    type="multi-file"
    [showValue]="false"
    class="pt-2 block"
    [maxFileSizeMB]="maxFileSizeMB"
    (fileError)="unauthorizedFileFormat($event)"
    (file)="selectedFile($event)"
    iconSize="15%"
  ></slm-drag-and-drop>
</slm-dialog-container>
